/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ command: NonNullable<unknown> }} Drastic_Tech_Extract_Command_LogInputs */



/**
* | output |
* | --- |
* | "Command: {command}" |
*
* @param {Drastic_Tech_Extract_Command_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_extract_command_log = /** @type {((inputs: Drastic_Tech_Extract_Command_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Extract_Command_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Commande : ${i?.command}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Befehl: ${i?.command}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Comando: ${i?.command}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Команда: ${i?.command}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Comando: ${i?.command}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`命令：${i?.command}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`コマンド: ${i?.command}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`कमांड: ${i?.command}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Comando: ${i?.command}`)
	return /** @type {LocalizedString} */ (`Command: ${i?.command}`)
});